import { FunctionComponent, useState } from 'react';
import classnames from 'classnames';

import Button, { ButtonElements, ButtonIconPositions, ButtonIconTypes, ButtonVariants } from 'components/layout/Button';
import LayoutContainer from 'components/layout/LayoutContainer';
import NewImage from 'components/layout/NewImage';
import DescriptionTwoCol from 'components/modules/public/layout/sections/DescriptionTwoCol';

import StyledComponent from './styles';
import { Props } from './types';

const PublicSectionCheckoutVariantWithQuotes: FunctionComponent<Props> = ({
    translations,
}) => {
    const [isExpanded, setIsExpanded] = useState<boolean>(false);
    const {
        description,
        expandedList,
        buttonLabelShow,
        buttonLabelHide,
    } = translations;

    return (
        <StyledComponent className="public-section-checkout-variant-with-quotes">
            <LayoutContainer>
                <div className="header">
                    <div className='apostrophe top'>
                        <NewImage
                            className="quote"
                            src='/images/quote.png'
                        />
                    </div>
                    <div
                        className="description"
                        dangerouslySetInnerHTML={{ __html: description }}
                    />
                    <div className='apostrophe bottom'>
                        <NewImage
                            className="quote"
                            src='/images/quote.png'
                        />
                    </div>
                </div>
                {isExpanded && (
                    <div className="section-list">
                        <DescriptionTwoCol
                            list={expandedList.map(expandedListElement => ({
                                key: expandedListElement.key,
                                leftCol: {
                                    copy: {
                                        headline: expandedListElement.headline,
                                        subheadline: expandedListElement.subheadline,
                                        description: expandedListElement.description,
                                    },
                                },
                                rightCol: {
                                    image: {
                                        imgProps: {
                                            src: expandedListElement.image,
                                        },
                                    },
                                },
                            }))}
                        />
                    </div>
                )}
                <div className="section-control">
                    <Button
                        onClick={() => setIsExpanded(!isExpanded)}
                        icon={{
                            value: '/images/home/arrow-down.svg',
                            position: ButtonIconPositions.After,
                            type: ButtonIconTypes.Image,
                        }}
                        variant={ButtonVariants.Outline}
                        element={ButtonElements.Button}
                        className={classnames(isExpanded && 'expand-state')}
                    >
                        {isExpanded ? buttonLabelHide : buttonLabelShow}
                    </Button>
                </div>
            </LayoutContainer>
        </StyledComponent>
    );
};

export default PublicSectionCheckoutVariantWithQuotes;
